import { Outlet } from 'react-router-dom';
import { Box, Toolbar } from '@mui/material';
import { Topbar } from './Topbar';
import { Sidebar } from './Sidebar';

export function AppLayout() {
  return (
    <Box sx={{ display: 'flex' }}>
      <Topbar />
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 3, bgcolor: 'background.default', minHeight: '100vh' }}>
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
